var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 4.1665C16.8877 4.1665 17.0996 4.2543 17.2559 4.41058C17.4122 4.56686 17.5 4.77882 17.5 4.99984C17.5 5.22085 17.4122 5.43281 17.2559 5.58909C17.0996 5.74537 16.8877 5.83317 16.6667 5.83317H15.8333L15.8308 5.89234L15.0533 16.7848C15.0234 17.2053 14.8352 17.5988 14.5268 17.8861C14.2183 18.1734 13.8124 18.3332 13.3908 18.3332H6.60833C6.18678 18.3332 5.78089 18.1734 5.4724 17.8861C5.16392 17.5988 4.97576 17.2053 4.94583 16.7848L4.16833 5.89317L4.16667 5.83317H3.33333C3.11232 5.83317 2.90036 5.74537 2.74408 5.58909C2.5878 5.43281 2.5 5.22085 2.5 4.99984C2.5 4.77882 2.5878 4.56686 2.74408 4.41058C2.90036 4.2543 3.11232 4.1665 3.33333 4.1665H16.6667ZM14.1642 5.83317H5.83583L6.60917 16.6665H13.3908L14.1642 5.83317ZM11.6667 1.6665C11.8877 1.6665 12.0996 1.7543 12.2559 1.91058C12.4122 2.06686 12.5 2.27882 12.5 2.49984C12.5 2.72085 12.4122 2.93281 12.2559 3.08909C12.0996 3.24537 11.8877 3.33317 11.6667 3.33317H8.33333C8.11232 3.33317 7.90036 3.24537 7.74408 3.08909C7.5878 2.93281 7.5 2.72085 7.5 2.49984C7.5 2.27882 7.5878 2.06686 7.74408 1.91058C7.90036 1.7543 8.11232 1.6665 8.33333 1.6665H11.6667Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.a4fa11d44ad209442817c1ae3d0c0ef3.svg";
export { ForwardRef as ReactComponent };